import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { withRouter } from "../../helpers/withRouter";

// Components
import Select from "../../components/Select";
import SelectSearcher from "../../components/SelectSearcher";
import BubbleBg from "../../components/BubbleBg";
import Aside from "../../components/Aside";
import FolderInfo from "../../components/FolderInfo";
import ModalInvitationFolder from "../../components/admin-modals/ModalInvitationFolder";
import ModalRanking from "../../components/admin-modals/ModalRanking";
import ModalIA from "../../components/admin-modals/ModalIA";
import ModalIAIntro from "../../components/admin-modals/ModalIAIntro";
import ModalInfoAction from "../../components/admin-modals/ModalInfoAction";
import ModalInput from "../../components/admin-modals/ModalInput";
import ModalCreate from "../../components/admin-modals/ModalCreate";
import TableToolsNew from "../../components/TableToolsNew";
import Spinner from "../../components/Spinner";
import IllustrationLineSeparator from "../../components/IllustrationLineSeparator";
import Roles from "../../config/roles";
import ModalSelectOrganization from "../../components/admin-modals/ModalSelectOrganization";

// Actions
import {
  fetchFolder,
  fetchOrganization,
  fetchOrganizationGetAssessments,
  fetchOrganizationCreate,
  fetchFolderUpdate,
  fetchFolderCreateUsersFolder,
  fetchFolderDestroy,
  fetchFolderUpdateChart,
  fetchFolderDownloadScoreUsers,
  fetchAllFinnishedUsers,
  fetchFolderDownloadReports,
  fetchOrganizations,
  startSurveyFolder,
  fetchCopyFolder,
  fetchSwitchConfigFolder,
  fetchRankingProfileFolder,
  fetchUpdateRankingProfileFolder,
  fetchDestroyRankingProfileFolder,
  fetchCreateRankingProfileFolder,
  fetchIaInteraction,
} from "../../redux/admin/actions";

import { fetchLogout } from "../../redux/login/actions";
import IaConversation from "./IaConversation";

// Selectors
import { getOrganization, getOrganizations } from "../organizations/selector";

const Folder = (props) => {
  const [modals, setModals] = useState({});
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("");
  const [search, setSearch] = useState("");
  const [iaMode, setIaMode] = useState(false);
  const [iaResponse, setIaResponse] = useState("");
  const [iaHeader, setIaHeader] = useState("");
  const [iaAsks, setIaAsks] = useState([]);
  const [iaAskText, setIaAskText] = useState("");
  const [maxAsks, setMaxAsks] = useState(5);
  const [currentAsk, setCurrentAsk] = useState(1);
  const [exceedAsksLimit, setExceedAsksLimit] = useState(false);
  const [exceedAsksLimitAvailable, setExceedAsksLimitAvailable] = useState(true);

  const [showSelectors, setShowSelectors] = useState(false);
  const [optionsIa, setOptionsIa] = useState({});
  const [selection, setSelection] = useState({});
  const [selectionSelectors, setSelectionSelectors] = useState({});
  const [showAiCloseWarning, setShowAiCloseWarning] = useState(false);
  const [allFinnisedUsers, setAllFinnishedUsers] = useState([])

  const hasFetched = useRef(false);
  const isFirstRender = useRef(true);

  const options_1 = {
    Dirección: [
      "Director de operaciones",
      "Director de RRHH",
      "Project Manager",
    ],
    "Ventas y Atención": [
      "Ejecutivo de ventas",
      "Representante atención cliente",
      "Key Account Manager",
    ],
    RRHH: [
      "Especialista selección personal",
      "Formador / Coach",
      "Consultor de RRHH",
    ],
    Creativos: [
      "Diseñador gráfico / UX-UI",
      "Especialista marketing digital",
      "Desarrollador productos/servicios",
    ],
    Técnicos: [
      "Ingeniero de procesos",
      "Analista de datos",
      "Arquitecto de software",
    ],
    Administrativos: [
      "Asistente de dirección",
      "Coordinador logístico",
      "Auditor / Control calidad",
    ],
  };

  useEffect(() => {
    if (hasFetched.current) return;
      hasFetched.current = true;
    _fetchFolder();
    props.organizations.length === 0 && props.fetchOrganizations();
    props.organization === undefined &&
      props.fetchOrganization(props.router.params.organizationId, 1, 10);
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;                         
    }
    if (props.folder) {
      setLoading(true);
      props.fetchFolder(
        props.router.params.organizationId,
        props.router.params.folderId,
        1,
        20,
        search,
        filterStatus,
        undefined,
        undefined,
        () => setLoading(false),
      );
    }
  }, [search, filterStatus]);


  const _fetchFolder = () => {
    props.fetchFolder(
      props.router.params.organizationId,
      props.router.params.folderId,
      1,
      20,
      "",
      "",
      undefined,
      undefined,
      () => {
        // getDataChart();
        setLoading(false);
        setModals({});
      },
    );
  };

  useEffect(() => {
    if(selectionSelectors && selectionSelectors.id === 5){
      props.fetchAllFinnishedUsers(props.organization.data.id, props.folder.id, (users) => setAllFinnishedUsers(users), () => alert("Error all finnished users"))
    }
  }, [selectionSelectors])

  const submitEditFolder = (data) => {
    let organizationId = props.organization.data.id;
    let folderId = props.folder.id;

    props.fetchFolderUpdate(organizationId, folderId, { folder: data }, () => {
      setModals({
        type: "success",
        text: "The survey has been edited successfully!",
        action: () => setModals({}),
      });
      _fetchFolder();
      getDataChart();
    });
  };

  const actionModals = (type) => {
    let modal = {};
    if (type === "invite") {
      if (props.folder.survey !== "") {
        modal.type = type;
        modal.action = (data, file) => submitInvitation(data, file);
      } else {
        modal.type = "success";
        modal.text =
          "You must have a assessment assigned to be able to invite users. You can assign a assessment by editing the folder";
        modal.action = () => setModals({});
      }
    } else if (type === "navigation") {
      modal.type = type;
      modal.text = "Do you want to navigate to associated emails?";
      modal.action = () => submitNavigation();
    } else if (type === "createOrganization") {
      modal.type = type;
      modal.text = "New organization:";
      modal.action = (data) => submitCreateOrganization(data);
    } else if (type === "start_survey") {
      modal.type = type;
      modal.text = "Are you sure you want to start the survey?";
      modal.action = () => startSurvey();
    } else if (type === "edit") {
      modal.type = type;
      modal.text = "Edit survey";
      modal.action = (data) => submitEditFolder(data);
    } else if (type === "export") {
      modal.type = type;
      modal.text = "Export data";
      modal.action = (data) => {};
    } else if (type === "copy_folder") {
      getAssessments();
    } else if (type === "export_all") {
      modal.type = type;
      modal.text = "Download all reports";
      modal.action = (data, id) => downloadReports(data, id);
    } else if (type === "collective_report") {
      modal.type = type;
      modal.text = "Do you want to open collective reports?";
      modal.action = (type) => showCollectiveReport(type);
    } else if (type === "ranking_report") {
      modal.type = type;
      modal.text = "Ranking";
      modal.action = (selected_profile) => filterByProfile(selected_profile);
    } else if (type === "ia_modal_intro") {
      modal.type = type;
      modal.text = "IA ANALYZE";
      modal.action = (selected_profile) => alert("clicked");
    } else if (type === "ia_modal") {
      modal.type = type;
      modal.text = "IA ANALYZE";
      modal.action = (selected_profile) => alert("clicked");
    } else {
      modal.type = type;
      modal.action = () => {};
    }

    setModals(modal);
  };

  const filterByProfile = (selected_profile) => {
    const { id, name, organization_id } = props.folder;
    props.navigate(
      `/admin/organizations/${props.router.params.organizationId}/surveys/${id}/ranking_profiles/${selected_profile}`,
      {
        state: {
          folderId: id,
          folderName: name,
          selectedProfileId: selected_profile,
        },
      },
    );
  };

  const startSurvey = () => {
    let organizationId = props.organization.data.id;
    let folderId = props.folder.id;
    props.startSurveyFolder(
      organizationId,
      folderId,
      () => startSurveySuccess(),
      () => startSurveyError(),
    );
  };

  const startSurveySuccess = () => {
    successAction("successStartSurvey");
  };

  const startSurveyError = () => {
    alert("There was an error, please try again");
  };

  const submitInvitation = (emails, file) => {
    let organizationId = props.organization.data.id;
    let folderId = props.folder.id;

    if (emails.length > 0 || file !== undefined) {
      props.fetchFolderCreateUsersFolder(
        organizationId,
        folderId,
        { emails: emails, file: file },
        () => successAction("successInvitation"),
      );
    }
  };

  const submitDelete = () => {
    let organizationId = props.organization.data.id;
    let folderId = props.folder.id;

    props.fetchFolderDestroy(organizationId, folderId, () =>
      successAction("delete"),
    );
  };

  const successAction = (type) => {
    let modal = {};

    if (type === "successInvitation") {
      modal.type = type;
      modal.text = "Users added successfully!";
      modal.action = () => {
        _fetchFolder();
        getDataChart();
      };
    } else if (type === "successStartSurvey") {
      modal.type = type;
      modal.text = "Emails sent successfully!";
      modal.action = () => {
        setLoading(false);
        setModals({});
      };
    } else {
      props.navigate(
        "/admin/organizations/" + props.router.params.organizationId,
      );
    }
    setModals(modal);
  };

  const changeOrganization = (id) => {
    props.navigate(`/admin/organizations/${id}`);
  };

  const submitNavigation = () => {
    const { id, name, organization_id } = props.folder;
    props.navigate(
      `/admin/organizations/${props.router.params.organizationId}/surveys/${id}/emails`,
      {
        state: {
          folderId: id,
          folderName: name,
        },
      },
    );
  };

  const getAssessments = () => {
    props.fetchOrganizationGetAssessments(
      props.router.params.organizationId,
      () => {
        let modal = {};
        modal.type = "copy_folder";
        modal.text = "Copy Survey";
        modal.description =
          "This will copy all user to the new survey. It could take a while depending on the number of users.";
        modal.action = (data) => {};
        setModals(modal);
      },
    );
  };

  const submitCreateOrganization = (data) => {
    props.fetchOrganizationCreate(
      {
        organization: data,
        from_organization: props.router.params.organizationId,
      },
      () => {
        setModals({
          type: "success",
          text: "The organization has been created successfully!",
          action: () => setModals({}),
        });
        props.fetchOrganizations();
      },
    );
  };

  // Logout
  const closeSession = () => {
    removeAdminScopeClass();
    props.fetchLogout() && props.navigate("/signin");
  };

  // Remove s-admin Class
  const removeAdminScopeClass = () => {
    let sAdmin = document.querySelector(".s-admin");
    sAdmin && sAdmin.classList.remove("s-admin");
  };

  const getDataChart = (status = filterStatus) => {
    props.fetchFolderUpdateChart(
      props.router.params.organizationId,
      props.router.params.folderId,
      status,
      () => {},
      () => {},
    );
  };

  const downloadScoreUsers = (email, id) => {
    props.fetchFolderDownloadScoreUsers(
      props.router.params.organizationId,
      props.router.params.folderId,
      email.email,
      "crude",
      () =>
        setModals({
          type: "success",
          text: "The email has been sent successfully!",
          action: () => setModals({}),
        }),
    );
  };

  const downloadReports = (email, id) => {
    props.fetchFolderDownloadReports(
      props.router.params.organizationId,
      props.router.params.folderId,
      email.email,
      () =>
        setModals({
          type: "success",
          text: "The petition has been processed, after finishing we will send an email with a link to download all reports!",
          action: () => setModals({}),
        }),
    );
  };

  const showCollectiveReport = (type) => {
    setModals({});
    let url = `/t3/collective_reports/${props.folder.crypted_report_folder}${type == "pdf" ? ".pdf" : ""}`;
    window.open(url, "_blank");
  };
  const createCopyFolder = (data) => {
    props.fetchCopyFolder(
      props.router.params.organizationId,
      props.router.params.folderId,
      data,
      (repsonseJSON) => successCopy(),
    );
  };

  const successCopy = (repsonseJSON) => {
    setModals({
      type: "success",
      text: "The folder has been copied successfully!",
      action: () => setModals({}),
    });
  };

  const switchConfig = (key) => {
    props.fetchSwitchConfigFolder(
      props.router.params.organizationId,
      props.router.params.folderId,
      { key: key },
      (repsonseJSON) => {
        setModals({
          type: "success",
          text: "Configuration successfully updated!",
          action: () => {
            setLoading(true);
            _fetchFolder();
          },
        });
      },
    );
  };

  const goToEmails = () => {
    props.navigate(
      `/admin/organizations/${props.router.params.organizationId}/surveys/${props.folder.id}/emails`,
      {
        state: {
          folderId: props.folder.id,
          folderName: props.folder.name,
          title: props.folder.name,
        },
      },
    );
  };

  const goToConsent = () => {
    props.navigate(
      `/admin/organizations/${props.router.params.organizationId}/surveys/${props.folder.id}/consent`,
      {
        state: {
          folderId: props.folder.id,
          folderName: props.folder.name,
          title: props.folder.name,
        },
      },
    );
  };

  const createRanking = (data, success) => {
    props.fetchCreateRankingProfileFolder(
      props.router.params.organizationId,
      props.router.params.folderId,
      { ...data, folder_id: props.router.params.folderId },
      () => success(),
      () => {},
    );
  };

  const destroyRanking = (id, success) => {
    props.fetchDestroyRankingProfileFolder(
      props.router.params.organizationId,
      props.router.params.folderId,
      id,
      () => success(),
      () => {},
    );
  };
  const iaSelection = (selection) => {
    setModals("");
    setIaMode(true);
    setIaHeader(selection.text);
    setLoading(true);
    let data = {
      question_config: {
        step: selection.id,
        candidate_number: selection.candidate_number,
        group: selection.group,
        position: selection.position,
        email: selection.email,
      },
    };
    props.fetchIaInteraction(
      props.router.params.organizationId,
      props.router.params.folderId,
      data,
      (responseJSON) => successIa(responseJSON),
      (responseJSON) => errorIa(responseJSON),
    );
  };

  // Go to IA conversation directly without showing a modal in the middle
  const goToIAConversation = () => {
    setIaResponse("Preparando el contexto... ");
    setExceedAsksLimitAvailable(false); // Disable the limit of questions
    setModals("");
    setIaMode(true);
    //call
    let data = {
      question_config: {
        step: 7,
      },
    };
    props.fetchIaInteraction(
      props.router.params.organizationId,
      props.router.params.folderId,
      data,
      (responseJSON) => successIa(responseJSON),
      (responseJSON) => errorIa(responseJSON),
    );
  }

  const successIa = (response) => {
    console.log("OK", response);
    setIaResponse(response.response);
    setIaAsks([]);
    setLoading(false);
  };

  const successIaText = (response) => {
    console.log("OK", response);
    let new_iasks = iaAsks;
    new_iasks.push({ type: "ia", text: response.response });
    setIaAsks(new_iasks);
    setIaAskText("");
    setCurrentAsk(currentAsk + 1);
    setLoading(false);
  };
  const errorIa = (response) => {
    console.log("OK", response);
    setLoading(false);
  };

  const sendIaAsk = () => {
    let new_iasks = iaAsks;
    new_iasks.push({ type: "user", text: iaAskText });
    setIaAsks(new_iasks);
    setModals("");
    setIaMode(true);
    setLoading(true);
    let data = {
      question_config: {
        step: 6,
        text: iaAskText,
      },
    };
    
    setIaAskText("");

    props.fetchIaInteraction(
      props.router.params.organizationId,
      props.router.params.folderId,
      data,
      (responseJSON) => successIaText(responseJSON),
      (responseJSON) => errorIa(responseJSON),
    );
  };

  

  const handleSendIaAsk = () => {
    // If the questions are limited
    if (exceedAsksLimitAvailable) {
      if (currentAsk < maxAsks) {
        sendIaAsk();
        if (exceedAsksLimit) {
          setExceedAsksLimit(false);
        }
      } else {
        setExceedAsksLimit(true);
      }
    } else {
      sendIaAsk();
    }
  };

  const handleCloseAi = () => {
    setIaResponse("")
    setIaHeader("");
    setIaAsks([]);
    setShowAiCloseWarning(false);
    setIaMode(false);
    setShowSelectors(false);
  }


  const { fetchFolder, router } = props;

  const handleGetUsers = useCallback(() => {
    fetchFolder(
      router.params.organizationId,
      router.params.folderId,
      1, 20, search, filterStatus,
      undefined, undefined,
      () => setLoading(false),
    );
  }, [search, filterStatus, fetchFolder, router.params.organizationId, router.params.folderId]);

  const handleToPage = useCallback((page, typeOrder, modeOrder) => {
    setLoading(true);
    fetchFolder(
      router.params.organizationId,
      router.params.folderId,
      page, 20, search, filterStatus,
      typeOrder, modeOrder,
      () => setLoading(false),
    );
  }, [search, filterStatus, fetchFolder, router.params.organizationId, router.params.folderId]);

  return (
    <motion.section
      className="o-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <BubbleBg />

      {props.organizations &&
        props.organizations.length > 0 &&
        props.organization &&
        props.organization.data && (
          <Aside
            history={props.history}
            label={"Select organization:"}
            showSelect={true}
            organizations={props.organizations}
            organization={props.organization}
            selectAction={(id) => changeOrganization(id)}
            createOrganization={() => getAssessments()}
            selectOrganization={() => setModals("selectOrganization")}
            showModalSession={() =>
              setModals({
                type: "closeSession",
                text: "Are you sure you want to logout?",
                action: () => closeSession(),
              })
            }
          />
        )}

      <div className="o-container o-container--overflow-disabled">
        <FolderInfo
          totalUsers={props.folder && props.folder.user.length}
          data={props.folder && props.folder}
          chart={props.chart}
          canManage={
            props.organization &&
            props.organization.user_role !== Roles.admin.READER
          }
          startSurvey={() => actionModals("start_survey")}
          editFolder={() => actionModals("edit")}
          openExportModal={() => actionModals("export")}
          openCopyFolder={() => actionModals("copy_folder")}
          openDownloadReportsModal={() => actionModals("export_all")}
          openCollectiveReportsModal={() => actionModals("collective_report")}
          openRankingReportsModal={() => actionModals("ranking_report")}
          switchConfig={(key) => switchConfig(key)}
          collective_report_enabled={
            props.folder && props.folder.collective_report
          }
          goToEmails={() => goToEmails()}
          goToConsent={() => goToConsent()}
          has_procedures={
            props.folder && props.folder.has_procedures ? true : false
          }
          axis_ranking_enabled={
            props.folder && props.folder.axis_ranking_enabled
          }
          openIaModal={() => actionModals("ia_modal_intro")}
        />

        <IllustrationLineSeparator />
        {!iaMode && !showSelectors && (
          <div className="o-margin--top-size-xl o-display--flex o-display--flex-v-center">
            <h4 className="o-margin--right-size-l">Users list</h4>
            {props.organization &&
              props.organization.user_role !== Roles.admin.READER && (
                <button
                  type="button"
                  className={"c-button c-button--margin-zero"}
                  onClick={() => {
                    props.folder && props.folder.has_procedures
                      ? props.navigate(
                          `/admin/organizations/${props.router.params.organizationId}/procedures/${props.folder.procedure_id}`,
                        )
                      : actionModals("invite");
                  }}
                >
                  <span className="c-button__text">
                    {props.folder && props.folder.has_procedures
                      ? "Survey linked to procedure"
                      : "Add users"}
                  </span>
                </button>
              )}
          </div>
        )}

        {!iaMode && showSelectors && (
          <div>
            <p>{selectionSelectors.title}</p>
            {selectionSelectors.id === 1 && (
              <div>
                <div style={{ display: "flex", gap: 24, marginTop: 24 }}>
                  <div style={{ flex: 1 }}>
                    <Select
                      className="c-select--white-bg c-select--border"
                      label="Puesto"
                      withoutInput
                      isRequired
                      valueSelected={optionsIa.group}
                      options={[
                        { text: "Dirección", value: "Dirección" },
                        {
                          text: "Ventas y Atención",
                          value: "Ventas y Atención",
                        },
                        { text: "RRHH", value: "RRHH" },
                        { text: "Creativos", value: "Creativos" },
                        { text: "Técnicos", value: "Técnicos" },
                        { text: "Administrativos", value: "Administrativos" },
                      ]}
                      optionClick={(text, value) =>
                        setOptionsIa({ ...optionsIa, group: value })
                      }
                      style={{ zIndex: 1005 }}
                      tick
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Select
                      className="c-select--white-bg c-select--border"
                      label="Posición"
                      withoutInput
                      isRequired
                      valueSelected={optionsIa.position}
                      options={
                        options_1[optionsIa.group]?.map((e) => ({
                          text: e,
                          value: e,
                        })) || []
                      }
                      optionClick={(text, value) =>
                        setOptionsIa({ ...optionsIa, position: value })
                      }
                      style={{ zIndex: 1005 }}
                      tick
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Select
                      className="c-select--white-bg c-select--border"
                      label="Numero de candidatos"
                      withoutInput
                      isRequired
                      valueSelected={optionsIa.candidate_number}
                      options={[
                        { text: 1, value: 1 },
                        { text: 2, value: 2 },
                        { text: 3, value: 3 },
                        { text: 4, value: 4 },
                        { text: 5, value: 5 },
                        { text: 6, value: 6 },
                        { text: 7, value: 7 },
                        { text: 8, value: 8 },
                        { text: 9, value: 9 },
                        { text: 10, value: 10 },
                        { text: 11, value: 11 },
                        { text: 12, value: 12 },
                        { text: 13, value: 13 },
                        { text: 14, value: 14 },
                        { text: 15, value: 15 },
                        { text: 16, value: 16 },
                        { text: 17, value: 17 },
                        { text: 18, value: 18 },
                        { text: 19, value: 19 },
                        { text: 20, value: 20 },
                      ]}
                      optionClick={(text, value) =>
                        setOptionsIa({ ...optionsIa, candidate_number: value })
                      }
                      style={{ zIndex: 1005 }}
                      tick
                    />
                  </div>
                </div>
                <div className="c-button__wrapper">
                  <button
                    onClick={() => {
                      setSelection({});
                      setShowSelectors(false);
                    }}
                    style={{ marginBottom: 10, marginRight: 10 }}
                    className="c-button c-button--cancel"
                  >
                    <span className="c-button__text">Cancel</span>
                  </button>
                  <button
                    type="button"
                    className="c-button c-modal__button"
                    onClick={() =>
                      iaSelection({ ...selectionSelectors, ...optionsIa })
                    }
                  >
                    <span className="c-button__text">Go</span>
                  </button>
                </div>
              </div>
            )}
            {selectionSelectors.id === 5 && allFinnisedUsers && allFinnisedUsers.users && (
              <div style={{ width: 400 }}>
                <div>
                  <SelectSearcher
                    className="c-select--white-bg c-select--border"
                    label="Candidato"
                    isRequired
                    valueSelected={optionsIa.email}
                    options={
                      allFinnisedUsers.users || []
                    }
                    onChange={(text, value) => {
                      const tempObj = { ...optionsIa }
                      delete tempObj.email
                      setOptionsIa({ ...tempObj })
                    }}
                    optionClick={(text, value) =>
                      setOptionsIa({ ...optionsIa, email: value })
                    }
                    style={{ zIndex: 1005 }}
                    tick
                  />
                </div>
                <div style={{ display: "flex" }}>
                  <button
                    onClick={() => {
                      setSelection({});
                      setShowSelectors(false);
                    }}
                    style={{ marginBottom: 10, marginRight: 10 }}
                    className="c-button c-button--cancel"
                  >
                    <span className="c-button__text">Cancel</span>
                  </button>
                  <button
                    type="button"
                    className="c-button c-modal__button"
                    onClick={() =>
                      iaSelection({ ...selectionSelectors, ...optionsIa })
                    }
                  >
                    <span className="c-button__text">Go</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {iaMode && (
          <IaConversation
            iaHeader={iaHeader}
            iaResponse={iaResponse}
            iaAsks={iaAsks}
            iaAskText={iaAskText}
            tilte={props.title}
            setIaAskText={setIaAskText}
            sendIaAsk={handleSendIaAsk}
            maxAsks={maxAsks}
            currentAsk={currentAsk}
            exceedAsksLimit={exceedAsksLimit}
            exceedAsksLimitAvailable={exceedAsksLimitAvailable}
            handleCloseAi={() => setShowAiCloseWarning(true)}
          />
        )}

        {!iaMode && !showSelectors && props.folder ? (
          <>
            <TableToolsNew
              newPagination={true}
              data={props.folder}
              getDataChart={(status) => getDataChart(status)}
              titleTableFilter="Users list"
              canManage={
                props.organization &&
                props.organization.user_role !== Roles.admin.READER
              }
              getUsers={handleGetUsers}
              toPage={handleToPage}
              search={search}
              setSearch={(search_new) => {search_new !== search && setSearch(search_new)}}
              organizationId={props.router.params.organizationId}
              folderId={props.router.params.folderId}
              setFilterStatus={(status) => {
                setFilterStatus(status);
              }}
              filterStatus={filterStatus}
              organizations={props.organizations_select}
              survey={props.folder.survey}
            />
          </>
        ) : (
          !iaMode &&
          !showSelectors && (
            <>
              <h2 className="o-margin--top-size-xxl o-margin--bottom-size-xxl o-text-align--center">
                No users yet
              </h2>
              <IllustrationLineSeparator />
            </>
          )
        )}
      </div>

      {["createOrganization", "edit"].includes(modals.type) && (
        <ModalCreate
          showModal={true}
          closeModal={() => setModals("")}
          editAction={(data) => modals.action(data)}
          defaultData={props.folder}
          type={modals.type}
          title={modals.text}
          assessments={props.folder.assessments}
          biodataOptions={props.organization.data.biodata_options}
        />
      )}

      {modals.type === "invite" && (
        <ModalInvitationFolder
          showModalInvitationFolder={modals.type === "invite"}
          closeInvitationFolder={() => setModals("")}
          invitationAction={(data, file) => modals.action(data, file)}
        />
      )}
      {modals === "selectOrganization" && (
        <ModalSelectOrganization
          history={props.history}
          organizations={props.organizations_select}
          closeModal={() => setModals("")}
        />
      )}
      {modals.type === "ranking_report" && (
        <ModalRanking
          data={modals}
          ranking_data={props.folder.ranking_data}
          showModalInvitationFolder={modals.type === "invite"}
          closeInvitationFolder={() => setModals("")}
          selectedProfile={(profiled_selected) =>
            modals.action(profiled_selected)
          }
          createRanking={(data, success) => createRanking(data, success)}
          destroyRanking={(id, success) => destroyRanking(id, success)}
          fetchRankingProfile={(success, error) =>
            props.fetchRankingProfileFolder(
              props.router.params.organizationId,
              props.router.params.folderId,
              (repsonseJSON) => success(repsonseJSON),
              () => error(),
            )
          }
        />
      )}

      {[
        "navigation",
        "successInvitation",
        "success",
        "start_survey",
        "successStartSurvey",
        "closeSession",
        "errorImport",
        "collective_report",
      ].includes(modals.type) && (
        <ModalInfoAction
          showModalInfoAction={true}
          noButtonCancel={[
            "successStartSurvey",
            "successInvitation",
            "success",
            "errorImport",
          ].includes(modals.type)}
          closeModalInfoAction={() => setModals("")}
          text={modals.text}
          secondButton={modals.type === "collective_report"}
          secondButtonText={"PDF"}
          primaryButtonText={
            modals.type === "collective_report" ? "Interactive" : "Confirm"
          }
          secondAction={() => modals.action("pdf")}
          action={() => modals.action("html")}
        />
      )}
      {showAiCloseWarning && (
        <ModalInfoAction
          showModalInfoAction={true}
          closeModalInfoAction={() => setShowAiCloseWarning(!showAiCloseWarning)}
          text={"¿ Deseas abandonar la conversación ?"}
          cancelButtonText={"Cancelar"}
          primaryButtonText={"Confirmar"}
          action={handleCloseAi}
        />
      )}

      {["export"].includes(modals.type) && (
        <ModalInput
          title={"Export data"}
          description="Enter your email in order to send you the exported file."
          data={{}}
          showModal={true}
          closeModal={() => setModals("")}
          action={(data, id) => downloadScoreUsers(data, id)}
          type={"user"}
          edit={true}
          canManage={props.canManage === undefined ? true : props.canManage}
        />
      )}

      {["export_all"].includes(modals.type) && (
        <ModalInput
          title={modals.text}
          description="Enter your email in order to send you the reports link file."
          data={{}}
          showModal={true}
          closeModal={() => setModals("")}
          action={(data, id) => modals.action(data, id)}
          type={"user"}
          edit={true}
          canManage={props.canManage === undefined ? true : props.canManage}
        />
      )}

      {["copy_folder"].includes(modals.type) && (
        <ModalCreate
          showModal={true}
          closeModal={() => setModals("")}
          editAction={(data) => createCopyFolder(data)}
          defaultData={undefined}
          type={modals.type}
          title={"Copy Survey"}
          description={modals.description}
          assessments={props.organization.data.assessments}
        />
      )}

      {["ia_modal_intro"].includes(modals.type) && (
        <ModalIAIntro
          users={
            props.folder
              ? props.folder.user.filter((u) => u.status === "completed")
              : []
          }
          closeModal={() => setModals("")}
          openNextModal={() => actionModals("ia_modal")}
          goToIAConversation={goToIAConversation}
        />
      )}

      {["ia_modal"].includes(modals.type) && (
        <ModalIA
          users={
            props.folder
              ? props.folder.user.filter((u) => u.status === "completed")
              : []
          }
          closeModal={() => setModals("")}
          iaSelection={(selection) => iaSelection(selection)}
          handleShowSelectors={(selection) => {
            setShowSelectors(true);
            setSelectionSelectors(selection);
            setModals("");
          }}
          handleSetSelection={(selection) => setSelection(selection)}
        />
      )}

      {loading && <Spinner />}
    </motion.section>
  );
};

Folder.propTypes = {
  folder: PropTypes.object,
};

const mapStateToProps = (state, props) => {
  return {
    folder: state.admin.folder,
    chart: state.admin.chart,
    organization: getOrganization(state, props),
    organizations: getOrganizations(state, props),
    assessments: state.admin.assessments,
    organizations_select: state.admin.organizations_select,
  };
};

const mapDispatchToProps = {
  fetchFolder,
  fetchOrganizations,
  fetchOrganization,
  fetchOrganizationGetAssessments,
  fetchOrganizationCreate,
  fetchFolderUpdate,
  fetchFolderCreateUsersFolder,
  fetchFolderDestroy,
  fetchFolderUpdateChart,
  fetchFolderDownloadScoreUsers,
  fetchAllFinnishedUsers,
  fetchFolderDownloadReports,
  startSurveyFolder,
  fetchLogout,
  fetchCopyFolder,
  fetchSwitchConfigFolder,
  fetchRankingProfileFolder,
  fetchUpdateRankingProfileFolder,
  fetchDestroyRankingProfileFolder,
  fetchCreateRankingProfileFolder,
  fetchIaInteraction,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Folder));
